import { defaultInitialState } from 'utils/defaultInitialState.ts.ts';
import { createFormBasedSliceReducers } from 'utils/redux.ts';
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import {
    DocumentSupplierPurchasesMaterialsSliceInitialState
} from 'components/Supply/DocumentSupplierPurchases/DocumentSupplierPurchases.types.ts';
import { FindDocumentSupplierMaterialResponseDto } from 'store/api/documentSupplierMaterial.tsx';

const documentSupplierMaterialsSliceInitialState: DocumentSupplierPurchasesMaterialsSliceInitialState = {
    ...defaultInitialState,
    originalMaterials: []
}

const reducers = createFormBasedSliceReducers<any>()

export const documentSupplierMaterialsSlice = createSlice({
    name: 'documentSupplierMaterials',
    initialState: documentSupplierMaterialsSliceInitialState,
    reducers: {
        ...reducers,
        setOriginalMaterials: (state: Draft<DocumentSupplierPurchasesMaterialsSliceInitialState>, action: PayloadAction<FindDocumentSupplierMaterialResponseDto[]>) => {
            state.originalMaterials = action.payload
        },
    }
}
)


export default documentSupplierMaterialsSlice.reducer